var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.255%",
    y1: "23.255%",
    x2: "123.445%",
    y2: "123.445%",
    id: "4wii982b5a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.85%",
    y1: "29.89%",
    x2: "84.91%",
    y2: "119.18%",
    id: "qwn3tpdseb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: ".8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-8.836-7.164-16-16-16S0 7.164 0 16s7.164 16 16 16 16-7.164 16-16z",
    fill: "url(#4wii982b5a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16c0 4.417-3.583 8-8 8s-8-3.583-8-8 3.583-8 8-8 8 3.583 8 8z",
    fill: "url(#qwn3tpdseb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJp);
export default __webpack_public_path__ + "static/media/jp.1561f4950ac9039c9209eaf739f1933b.svg";
export { ForwardRef as ReactComponent };